import { all, takeEvery, put, fork, call } from 'redux-saga/effects';

import { 
	ADD_SERVICE, 
	DELETE_SERVICE, 
	EDIT_SERVICE, 
	GET_SERVICES,
	GET_BRANCHS,
	EDIT_BRANCH,
	ADD_BRANCH,
	GET_LANGUAGES,
	EDIT_LANGUAGE,
	ADD_LANGUAGE,
	GET_COMPLETION_TIMES,
	EDIT_COMPLETION_TIME,
	ADD_COMPLETION_TIME,
	GET_WORDS,
	EDIT_WORD,
	ADD_WORD,
	GET_VIEWS
} from 'redux/constants/Settings';
import { 
	addServiceService, 
	deleteServiceService, 
	editServiceService, 
	getServicesService,
	getBranchsService,
	editBranchService,
	addBranchService,
	getLanguagesService,
	editLanguageService,
	addLanguageService,
	getCompletionTimesService,
	editCompletionTimeService,
	addCompletionTimeService,
	getWordsService,
	editWordService,
	addWordService,
	getViewsService,
	getAnnualStatisticsService
} from 'redux/services/Settings';
import { 
	addServiceError, 
	addServiceSuccess, 
	deleteServiceError, 
	deleteServiceSuccess, 
	editServiceError, 
	editServiceSuccess, 
	getServicesError, 
	getServicesSuccess,

	getBranchsError,
	getBranchsSuccess,
	editBranchError,
	editBranchSuccess,
	addBranchError,
	addBranchSuccess,
	
	getCompletionTimesSuccess,
	getCompletionTimesError,
	editCompletionTimeSuccess,
	editCompletionTimeError,
	addCompletionTimeSuccess,
	addCompletionTimeError,

	getLanguagesError,
	getLanguagesSuccess,
	editLanguageError,
	editLanguageSuccess,
	addLanguageError,
	addLanguageSuccess,

	getWordsSuccess,
	getWordsError,
	editWordSuccess,
	editWordError,
	addWordSuccess,
	addWordError,
	getViewsError,
	getViewsSuccess,
	getAnnualStatisticsError,
	getAnnualStatisticsSuccess
} from "../actions/Settings";

export function* getServicesSaga() {
	yield takeEvery(GET_SERVICES, function* ({ payload }) {
		try {
			const data = yield call(getServicesService);
			if (data.message) {
				yield put(getServicesError(data.message));
			} else {
				yield put(getServicesSuccess(data));
			}
		} catch (err) {
			yield put(getServicesError(err));
		}
	});
}

export function* editServiceSaga() {
	yield takeEvery(EDIT_SERVICE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editServiceService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editServiceError(result.message));
			} else {
				yield call(cb, { message: 'Service saved', type: 'success' });
				yield put(editServiceSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editServiceError(err));
		}
	});
}

export function* addServiceSaga() {
	yield takeEvery(ADD_SERVICE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addServiceService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addServiceError(result.message));
			} else {
				yield call(cb, { message: 'Service saved', type: 'success' });
				yield put(addServiceSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addServiceError(err));
		}
	});
}

export function* deleteServiceSaga() {
	yield takeEvery(DELETE_SERVICE, function* ({ payload }) {
		const { id, cb } = payload;
		try {
			const result = yield call(deleteServiceService, id);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(deleteServiceError(result.message));
			} else {
				yield call(cb, { message: 'Service deleted', type: 'success' });
				yield put(deleteServiceSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(deleteServiceError(err));
		}
	});
}

export function* getBranchsSaga() {
	yield takeEvery(GET_BRANCHS, function* ({ payload }) {
		try {
			const data = yield call(getBranchsService);
			if (data.message) {
				yield put(getBranchsError(data.message));
			} else {
				yield put(getBranchsSuccess(data));
			}
		} catch (err) {
			yield put(getBranchsError(err));
		}
	});
}

export function* editBranchSaga() {
	yield takeEvery(EDIT_BRANCH, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editBranchService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editBranchError(result.message));
			} else {
				yield call(cb, { message: 'Branch saved', type: 'success' });
				yield put(editBranchSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editBranchError(err));
		}
	});
}

export function* addBranchSaga() {
	yield takeEvery(ADD_BRANCH, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addBranchService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addBranchError(result.message));
			} else {
				yield call(cb, { message: 'Branch saved', type: 'success' });
				yield put(addBranchSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addBranchError(err));
		}
	});
}

export function* getLanguagesSaga() {
	yield takeEvery(GET_LANGUAGES, function* ({ payload }) {
		try {
			const data = yield call(getLanguagesService);
			if (data.message) {
				yield put(getLanguagesError(data.message));
			} else {
				yield put(getLanguagesSuccess(data));
			}
		} catch (err) {
			yield put(getLanguagesError(err));
		}
	});
}

export function* editLanguageSaga() {
	yield takeEvery(EDIT_LANGUAGE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editLanguageService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editLanguageError(result.message));
			} else {
				yield call(cb, { message: 'Language saved', type: 'success' });
				yield put(editLanguageSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editLanguageError(err));
		}
	});
}

export function* addLanguageSaga() {
	yield takeEvery(ADD_LANGUAGE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addLanguageService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addLanguageError(result.message));
			} else {
				yield call(cb, { message: 'Language saved', type: 'success' });
				yield put(addLanguageSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addLanguageError(err));
		}
	});
}

export function* getCompletionTimesSaga() {
	yield takeEvery(GET_COMPLETION_TIMES, function* ({ payload }) {
		try {
			const data = yield call(getCompletionTimesService);
			if (data.message) {
				yield put(getCompletionTimesError(data.message));
			} else {
				yield put(getCompletionTimesSuccess(data));
			}
		} catch (err) {
			yield put(getCompletionTimesError(err));
		}
	});
}

export function* editCompletionTimeSaga() {
	yield takeEvery(EDIT_COMPLETION_TIME, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editCompletionTimeService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editCompletionTimeError(result.message));
			} else {
				yield call(cb, { message: 'Completion Time saved', type: 'success' });
				yield put(editCompletionTimeSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editCompletionTimeError(err));
		}
	});
}

export function* addCompletionTimeSaga() {
	yield takeEvery(ADD_COMPLETION_TIME, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addCompletionTimeService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addCompletionTimeError(result.message));
			} else {
				yield call(cb, { message: 'Comletion Time saved', type: 'success' });
				yield put(addCompletionTimeSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addCompletionTimeError(err));
		}
	});
}

export function* getWordsSaga() {
	yield takeEvery(GET_WORDS, function* ({ payload }) {
		try {
			const data = yield call(getWordsService);
			if (data.message) {
				yield put(getWordsError(data.message));
			} else {
				yield put(getWordsSuccess(data));
			}
		} catch (err) {
			yield put(getWordsError(err));
		}
	});
}

export function* editWordSaga() {
	yield takeEvery(EDIT_WORD, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editWordService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editWordError(result.message));
			} else {
				yield call(cb, { message: 'Word saved', type: 'success' });
				yield put(editWordSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editWordError(err));
		}
	});
}

export function* addWordSaga() {
	yield takeEvery(ADD_WORD, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addWordService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addWordError(result.message));
			} else {
				yield call(cb, { message: 'Word saved', type: 'success' });
				yield put(addWordSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addWordError(err));
		}
	});
}

export function* getViewsSaga() {
	yield takeEvery(GET_VIEWS, function* ({ payload }) {
		try {
			const { country } = payload;
			
			const data = yield call(getViewsService, country);
			if (data.message) {
				yield put(getViewsError(data.message));
			} else {
				yield put(getViewsSuccess(data));
			}
		} catch (err) {
			yield put(getViewsError(err));
		}
	});
}

export function* getAnnualStatisticsSaga() {
	yield takeEvery(GET_VIEWS, function* ({ payload }) {
		try {
			const data = yield call(getAnnualStatisticsService);
			if (data.message) {
				yield put(getAnnualStatisticsError(data.message));
			} else {
				yield put(getAnnualStatisticsSuccess(data));
			}
		} catch (err) {
			yield put(getAnnualStatisticsError(err));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getServicesSaga),
		fork(editServiceSaga),
		fork(addServiceSaga),
		fork(deleteServiceSaga),

		fork(getBranchsSaga),
		fork(editBranchSaga),
		fork(addBranchSaga),

		fork(getLanguagesSaga),
		fork(editLanguageSaga),
		fork(addLanguageSaga),

		fork(getCompletionTimesSaga),
		fork(editCompletionTimeSaga),
		fork(addCompletionTimeSaga),

		fork(getWordsSaga),
		fork(editWordSaga),
		fork(addWordSaga),

		fork(getViewsSaga),
		fork(getAnnualStatisticsSaga)
	]);
}
